export default "__VITE_ASSET__DwSTbzDo__"